<template>
  <div style="height:100%">
    <div class="d-md-down-none el-tabs-container">
      <el-tabs v-model="tab_index">
        <el-tab-pane label="分配管理">
          <span slot="label"><i class="iconfont icon-dispatch2" style="font-size: 14px"></i>&nbsp;{{
            $t("tab.tab_so_dispatch") }}</span>
          <saleOrderDispatchSearch></saleOrderDispatchSearch>
        </el-tab-pane>
        <el-tab-pane label="查询(明细列表)">
          <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{
            $t("tab.tab_so_dispatch_detail") }}</span>
          <saleOrderDispatchItems></saleOrderDispatchItems>
        </el-tab-pane>
        <el-tab-pane label="查询(供应商)">
          <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{
            $t("tab.tab_so_dispatch_detail_vend") }}</span>
          <saleOrderDispatchVendSearch></saleOrderDispatchVendSearch>
        </el-tab-pane>
        <el-tab-pane label="新建产能分配">
          <span slot="label"><i class="iconfont icon-add-new" style="font-size: 14px"></i>&nbsp;{{
            $t("tab.tab_so_dispatch_create") }}</span>
          <saleOrderDispatchAdd></saleOrderDispatchAdd>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="d-lg-none page_component__scroll" mobile style="height:100%;overflow:auto">
      <b-button variant="primary" class="mb-2" size="sm" v-show="sod_items.length > 0"
        @click="excuteAction(null, 'all_approve')">全部批准</b-button>
      <b-button variant="outline-danger" class="mb-2 ml-2" size="sm" v-show="sod_items.length > 0"
        @click="excuteAction(null, 'all_refuse')">全部退回
      </b-button>
      <div v-for="(main, index) in sod_items" :key="index">
        <el-card class="box-card mb-1 " :body-style="{ padding: '8px' }" v-for="(item, k) in main.children" :key="k">
          <div slot="header" class="clearfix">
            <span>{{ '销售订单编号：' + main.SalesId + '，行号：' + item.LineNum }}</span>
          </div>
          <div v-for="(child, k) in item.children" :key="k" class="mb-2">
            <el-descriptions class="margin-top mb-1" :column="1" border>
              <el-descriptions-item label="派发编号" :span="2">
                {{ child.id }}
              </el-descriptions-item>
              <el-descriptions-item label="供应商" :span="2">
                {{ child.SEI_Name }}
              </el-descriptions-item>
              <el-descriptions-item label="物料编号" :span="2">
                {{ child.ItemId }}
              </el-descriptions-item>
              <el-descriptions-item label="物料名称" :span="2">
                <span style="width:100px;">{{ child.NameAlias }}</span>
              </el-descriptions-item>
              <el-descriptions-item label="派发数量" :span="2">
                {{ child.qty }}
              </el-descriptions-item>
              <el-descriptions-item label="初始报价" :span="2">
                {{ child.price_vend }}
              </el-descriptions-item>
              <el-descriptions-item label="实际采购价" :span="2">
                {{ child.price }}
              </el-descriptions-item>
              <el-descriptions-item label="实际采购价备注" :span="2">
                {{ child.PriceRemark }}
              </el-descriptions-item>
              <el-descriptions-item label="实际毛利率(%)" :span="2">
                {{ child.ProfitRate }}
              </el-descriptions-item>
              <el-descriptions-item label="初始报价毛利率(%)" :span="2">
                {{ child.InitialProfitRate }}
              </el-descriptions-item>
              <el-descriptions-item label="申请人" :span="2">
                {{ child.create_by_username }}
              </el-descriptions-item>
              <el-descriptions-item label="申请时间" :span="2">
                {{ child.create_at }}
              </el-descriptions-item>
              <el-descriptions-item label="状态" :span="2">
                <el-tag v-if="!child.fcCheckDocumentRefused" type="danger">待批准</el-tag>
                <el-tag v-else type="info">已退回</el-tag>
              </el-descriptions-item>
            </el-descriptions>
            <el-input v-model="child.approve_context" type="textarea" :rows="2" placeholder="请输入审批意见"
              clearable></el-input>
            <el-button type="success" size="mini" class="mt-1" @click="excuteAction(child, 'approve')">批 准</el-button>
            <el-button size="mini" class="mt-1 ml-2" @click="excuteAction(child, 'refuse')">退 回</el-button>
          </div>
        </el-card>
      </div>
    </div>
    <el-backtop target=".page_component__scroll" class="d-lg-none" :visibility-height="100" :right="20"
      :bottom="70"></el-backtop>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import * as commonController from "../../controllers/commonController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as saleOrderDispatchAddController from "../../controllers/sd/saleOrderDispatchAddController"
import * as saleOrderDispatchItemsController from "../../controllers/sd/saleOrderDispatchItemsController"
import * as saleOrderDispatchSearchController from "../../controllers/sd/saleOrderDispatchSearchController"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import * as notify_template from "../../shared/notify_template"
import saleOrderDispatchAdd from "./saleOrderDispatchAdd"
import saleOrderDispatchItems from "./saleOrderDispatchItems"
import saleOrderDispatchSearch from "./saleOrderDispatchSearch"
import saleOrderDispatchVendSearch from "./saleOrderDispatchVendSearch"

export default {
  name: "saleOrderDispatch",
  components: {
    saleOrderDispatchSearch,
    saleOrderDispatchVendSearch,
    saleOrderDispatchAdd,
    saleOrderDispatchItems,
  },
  data() {
    return {
      tab_index: 0,
      sod_items: [],
      sod_items_his: [],
    }
  },

  watch: {
    "$route": {
      handler(val) {
        console.log(val)
        if (val && val.query.k) {
          this.tab_index = "1"
          this.on_query()
        }
      },
      deep: true
      // immediate: true
    },
  },
  mounted() {
    let val = this.$route
    if (val && val.query.k) {
      this.tab_index = "1"
      this.on_query()
    }
  },
  methods: {
    // 查询
    async on_query() {
      let _params = {}
      // _params.SalesId = salesId;

      let _result = await saleOrderDispatchItemsController.methods.getData(
        _params
      )
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.sod_items_his = _result[0]
        let dt = _.filter(_.orderBy(_result[0], ["createdDateTime"], ["desc"]), (t) => {
          if (t.fcGetDocumentApprover) {
            let _approver = t.fcGetDocumentApprover.split(",")[0]
            if (!t.fcCheckDocumentAllApproved && _approver == this.$global.global_data.local_username) {
              return t
            }
          }
        })
        let group_by_linenum = _.groupBy(dt, "SalesId")
        this.sod_items = []
        for (let i in group_by_linenum) {
          let main = {
            SalesId: i,
            children: []
          }
          for (let j in group_by_linenum[i]) {
            let m = {
              LineNum: group_by_linenum[i][j].LineNum,
              children: []
            }
            _.each(_.filter(group_by_linenum[i], { LineNum: m.LineNum }), (t) => {
              t.price_wotax == "" ? 0 : t.price_wotax
              t.price_vend_wotax == "" ? 0 : t.price_vend_wotax
              let c = {
                AccountNum: t.AccountNum,
                SEI_Name: t.SEI_Name,
                ItemId: t.ItemId,
                NameAlias: t.NameAlias,
                qty: t.qty,
                price_vend: t.price_vend_wotax,
                price: t.price_wotax,
                price_vend_show: _.round(t.price_vend_wotax, 2),
                price_show: _.round(t.price_wotax, 2),
                ProfitRate: t.Sales_Order_Price == 0 ? "-100%" : _.round((t.Sales_Order_Price - t.price_wotax) * 100 / t.Sales_Order_Price, 2), //(订单价格-实际采购价)/订单价格
                InitialProfitRate: t.Sales_Doc_Price == 0 ? "-100%" : _.round((t.Sales_Doc_Price - t.price_vend_wotax) * 100 / t.Sales_Doc_Price, 2), //(协议价格-初始采购价)/协议价格
                id: t.id,
                create_by_username: t.create_by_username,
                create_at: this.formatDate(t.create_at),
                fcGetDocumentApprover: t.fcGetDocumentApprover,
                fcCheckDocumentAllApproved: t.fcCheckDocumentAllApproved,
                fcCheckDocumentRefused: t.fcCheckDocumentRefused,
                PriceRemark: t.price_remark,
                approve_context: "同意"
              }
              m.children.push(c)
            })
            main.children.push(m)
          }
          this.sod_items.push(main)
        }
        console.log(this.sod_items)
      }
    },
    // 操作
    async excuteAction(item, code) {
      if (!await this.msgModal("确定要执行该操作吗？")) {
        return
      }
      let _list = []
      if (code == "all_approve" || code == "all_refuse") {
        _.each(this.sod_items, (s) => {
          _.each(s.children, (t) => {
            let m = _.find(this.sod_items_his, { id: t.id })
            if (m) {
              let _approve_remark = t.approve_context
              if (code == "all_refuse") {
                _approve_remark = t.approve_context == "同意" ? "退回" : t.approve_context
              }
              m.ApproveRemark = _approve_remark
              _list.push(m)
            }
          })
        })
      }
      else {
        let m = _.find(this.sod_items_his, { id: item.id })
        if (m) {
          let _approve_remark = item.approve_context
          if (code == "refuse") {
            _approve_remark = item.approve_context == "同意" ? "退回" : item.approve_context
          }
          m.ApproveRemark = _approve_remark
        }
        _list.push(m)
      }
      console.log(_list)

      //审批
      if (code == "all_approve" || code == "approve") {
        await this.excuteApproveAction(_list)
      }
      //拒批
      if (code == "all_refuse" || code == "refuse") {
        await this.excuteRefuseAction(_list)
      }
    },
    // 审批
    async excuteApproveAction(actionlist) {
      let res_msg = [], _exception_params = []
      let group_vend_list = _.groupBy(actionlist, "AccountNum")
      console.log(group_vend_list)
      for (let j in group_vend_list) {
        let _params_list = []
        let _list = _.cloneDeep(group_vend_list[j])
        let _p = {}
        ///1、审批数据
        _p.approve_data = await this.getUpdateApproveStatusParams(_list, true)

        ///2、订单明细剩余数量参数
        _p.update_valid_data = []
        _.each(_list, (l) => {
          let _index = _.findIndex(_p.update_valid_data, { id: l.SalesLineId })
          if (_index < 0) {
            _p.update_valid_data.push({ id: l.SalesLineId })
          }
        })

        ///3、AX接口
        let _approve_status = "Approve"
        _p.ax_data = this.getAXParams(_list, "", _approve_status)

        ///4、采购参数
        _p.purch_data = this.getCreatePurchaseParams(_list, true)
        _p.state = true
        _params_list.push(_p)
        let result = await saleOrderDispatchSearchController.methods.approveListData(_params_list)
        if (!_.isNull(result)) {
          if (!result.state) {
            let _venders = _.map(_list, "AccountNum")
            res_msg.push("<hr/><div>" + this.$t("common.provider") + this.$t("common.num") + "：" + _venders[0] + "，" + result.message + "</div>")
            for (let v in _list) {
              _exception_params.push({
                isAXError: true,
                AXError: result.message,
                id: _list[v].id
              })
            }
          }
        }
      }
      if (res_msg.length == 0) {
        this.msgToasts("执行成功！", "success")
      }
      else {
        this.msgToasts(this.$t("notify.ax_error") + "：" + _.join(res_msg, " "), "info", null, true)
        if (_exception_params.length > 0) {
          await saleOrderDispatchAddController.methods.updateSODAxState(_exception_params)
        }
      }

      //重新获取数据
      if (window.location.href.indexOf("?k=") > -1) {
        await this.on_query()
      }

      //审批后发邮件给下一级
      await this.SendEmail({ code: "add", is_not_notify: true }, actionlist)

      ///审批成功后发邮件
      let _emailList = _.filter(this.sod_items_his, (t) => {
        let aindex = _.findIndex(actionlist, { id: t.id })
        if (aindex > -1 && t.fcCheckDocumentAllApproved == true) {
          return t
        }
      })
      if (_emailList.length > 0) {
        let _ep = {
          notify_type: "sod_approve_pass",
          subject: "sod_approve_pass",
          idx: "id"
        }
        await this.sendEmailAfterApproved(_emailList, _ep)
      }
    },
    // 拒批
    async excuteRefuseAction(actionlist) {
      let _list = _.map(actionlist, (t) => {
        return {
          DocumentType: "SalesOrderDispatch",
          ItemId: t.id,
          Approver: this.$global.global_data.local_username,
          ApproveRemark: t.ApproveRemark
        }
      })
      let rt = await saleOrderDispatchSearchController.methods.refuseList(_list)
      if (rt && rt.state) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        //重新获取数据
        if (window.location.href.indexOf("?k=") > -1) {
          await this.on_query()
        }
      }
    },

    //#region 整理审批参数
    //获取修改审批的参数
    async getUpdateApproveStatusParams(_list, _state) {
      let _update_status_list = []
      let _roles = []
      if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
        _roles = _.map(
          this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
          "code"
        )
      }
      for (let i in _list) {
        _list[i].is_approved = _state
        let _as_result = await SalesOrderController.methods.getApproveStatus({
          DocumentType: "SalesOrderDispatch",
          ApproveType: "",
          ItemId: _list[i].id,
        })
        _.each(_as_result[0], (at) => {
          if (at) {
            if (_state) {
              if (_.includes(_roles, at.Approver) || this.$global.global_data.local_username == at.Approver) {
                at.is_approved = _state
                at.username = this.$global.global_data.local_username
                at.order_dispatch_id = _list[i].id
                at.userId = this.$store.state.biz_data.userInfo.user_id
                at.ApproveRemark = _list[i].ApproveRemark //审批备注
                _update_status_list.push(at)
              }
            } else {
              ///临时取消
              at.is_approved = _state
              at.username = this.$global.global_data.local_username
              at.order_dispatch_id = _list[i].id
              at.userId = this.$store.state.biz_data.userInfo.user_id
              at.ApproveRemark = _list[i].ApproveRemark //审批备注
              _update_status_list.push(at)
            }
          }
        })
      }
      return _update_status_list
    },
    ///整理ax参数
    getAXParams(_list, _Status, _ApproveStatus) {
      let _this = this
      ///整理jsonData
      let _jsonData = []

      let _soline_current = _list[0]
      for (let i in _list) {
        let t = _list[i]
        let _self_m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, {
          DataArea: t.dataAreaId,
        })
        if (_Status == "") {
          if (_.isNull(t.AXSalesId) || t.AXSalesId == "") {
            if (_ApproveStatus == "Draft") {
              continue
            }
          }
        }
        let _temp_Status = _Status
        let _AccountNum = t.AccountNum
        let _vendTaxGroup = t.VendTaxGroup ///供应商税组
        if (_vendTaxGroup == "") {
          let _vend = _.find(this.$store.state.biz_data.baseData.Vender, {
            AccountNum: t.AccountNum,
          })
          if (_vend) {
            _vendTaxGroup = _vend.TaxGroup
          }
        }
        if (_self_m && _self_m.VenderAccountNum == t.AccountNum) {
          _AccountNum = ""
        }
        if (_Status == "") {
          if (!_.isNull(t.AXSalesId) && t.AXSalesId != "") {
            _temp_Status = "Update"
          } else {
            _temp_Status = "Create"
          }
        }
        if (t.delivery_date && _.isDate(t.delivery_date)) {
          t.delivery_date = _this.$date.format(t.delivery_date, "yyyy-MM-dd")
        }
        let _purch_code = t.CurrencyCode
        if (t.PurchCurrencyCode && !_.isNull(t.PurchCurrencyCode)) {
          _purch_code = t.PurchCurrencyCode
        }
        let _AXInventTransRet = ""
        let _AXPurchInventTransRet = ""
        if (parseFloat(t.SalesQty) < 0) {
          _AXInventTransRet = t.AXInventTransRet
          _AXPurchInventTransRet = t.AXInventTransRet
        }

        _jsonData.push({
          OrderType: t.SalesPoolId != '预测订单' ? 'Sales' : 'Forecast',
          SalesId: t.SalesLineId,
          CustAccount: t.CustAccount,
          DeliveryDate: _this.$date.format(new Date(t.ConfirmedDlv.split("T")[0]), "yyyy-MM-dd"),
          TaxGroup: t.TaxGroup,
          SalesPoolId: t.SalesPoolId != '预测订单' ? (t.SalesPoolId ? t.SalesPoolId : '') : '产成品销售',
          InclTax: t.InclTax == "是" ? 1 : 0,
          TEC_Remark: t.TEC_Remark,
          TEC_FinalCustAccount: t.TEC_FinalCustAccount,
          LineNum: t.id,
          ItemId: t.ItemId,
          RetailVariantId: t.RetailVariantId,
          SalesPrice: t.SalesPrice,
          CurrencyCode: t.CurrencyCode,
          ConfirmedDlv: _this.$date.format(new Date(t.delivery_date.split("T")[0]), "yyyy-MM-dd"),
          SalesUnit: _.isEmpty(t.DW_InventUnitId) == true ? "个" : t.DW_InventUnitId,
          SalesQty: t.qty,
          TEC_CommonRemark: t.TEC_CommonRemark,
          TEC_CustSalesID: t.TEC_CustSalesID,
          TEC_LineAmountBak: "",
          SEI_OrderDateCust: _this.$date.format(new Date(t.SEI_OrderDateCust.split("T")[0]), "yyyy-MM-dd"),
          SEI_PriceUnitCust: t.SEI_PriceUnitCust,
          SEI_ShippingDateCust: _this.$date.format(new Date(t.SEI_ShippingDateCust.split("T")[0]), "yyyy-MM-dd"),
          // "dataAreaId": "070",
          VendAccount: _AccountNum,
          VendTaxGroup: _vendTaxGroup,
          AXInventTransRet: _AXInventTransRet,
          AXPurchInventTransRet: _AXPurchInventTransRet,
          SalesNO: t.SalesId, ///订单编号
          CreateBy: t.create_by_username,
          PurchPrice: t.price,
          PurchCurrencyCode: _purch_code,
          PurchDeliveryDate: _this.$date.format(new Date(t.delivery_date.split("T")[0]), "yyyy-MM-dd"),
          PurchUnit: _.isEmpty(t.DW_InventUnitId) == true ? "个" : t.DW_InventUnitId,
          Status: _temp_Status,
          AXSalesId: t.AXSalesId,
          AXInventTransId: t.AXInventTransId,
          AXPurchId: t.AXPurchId,
          AXPurchInventTransId: t.AXPurchInventTransId,
          AXSalesLineNum: _.isNull(t.AXSalesLineNum) ? "" : t.AXSalesLineNum,
          AXPurchLineNum: _.isNull(t.AXPurchLineNum) ? "" : t.AXPurchLineNum,
          ApproveStatus: _ApproveStatus,
          InventLocationId: t.DW_inventBatchIdSales,
          DeliveryAddress: t.DeliveryAddress //订单明细送货地址
        })
      }
      let _group_data = _.groupBy(_jsonData, "VendAccount")
      return {
        company: _soline_current.dataAreaId,
        jsonGroupData: _group_data,
      }
    },
    ///获取采购单参数
    getCreatePurchaseParams(data) {
      let result = { main: [], items: [], update_list: [] }
      let _create_list = []
      let _update_list = []
      ///仅初次审核才创建采购单
      _.each(data, (t) => {
        if (_.isEmpty(t.AXSalesId) || _.isNull(t.AXSalesId)) {
          _create_list.push(t)
        } else {
          _update_list.push(t)
        }
      })
      if (_create_list.length > 0) {
        let _group_list = _.groupBy(_create_list, "AccountNum")
        let order_master_list = []
        let order_item_list = []
        for (let i in _group_list) {
          let masterForm = {
            id: "",
            PurchId: "",
            OrderAccount: _group_list[i][0].AccountNum, //供应商账户
            OrderAccountName: _group_list[i][0].SEI_Name, //供应商名称
            CurrencyCode: _group_list[i][0].CurrencyCode,
            InclTax: _group_list[i][0].InclTax,
            dataAreaId: _group_list[i][0].dataAreaId, //公司
            AX_PurchId: "", //AX采购单编号
            AX_SalesOrderId: "", //AX销售单编号
          }
          order_master_list.push(masterForm)

          let _num = 1
          ///添加items
          for (let j in _group_list[i]) {
            let itemForm = {
              id: "",
              PurchaseOrderId: "",
              LineNumber: _num,
              ItemId: _group_list[i][j].ItemId,
              NameAlias: _group_list[i][j].NameAlias,
              PurchQty: _group_list[i][j].qty, //数量
              PurchPrice: _group_list[i][j].price,
              PurchUnit: _.isNull(_group_list[i][0]) ? "" : _group_list[i][0].SalesUnit,
              LineAmount: _group_list[i][j].qty * _group_list[i][j].price,
              dataAreaId: _group_list[i][0].dataAreaId, //公司
              RetailVariantId: _group_list[i][j].RetailVariantId,
              VariantName: _group_list[i][j].VariantName,
              DeliveryDate: _group_list[i][j].delivery_date,
              OrderDispatch_id: _group_list[i][j].id, //派单id
              AX_Line_PurchId: "", //AX采购单行编号
              AX_Line_SalesOrderId: "", //AX销售单行编号
              OrderAccount: _group_list[i][0].AccountNum,
            }
            order_item_list.push(itemForm)
            _num += 1
          }
        }

        result.main = order_master_list
        result.items = order_item_list
      }
      if (_update_list.length > 0) {
        _.each(_update_list, (t) => {
          result.update_list.push({
            OrderDispatch_id: t.id,
            is_approved: 1,
            is_deleted: 0,
          })
        })
      }
      return result
    },
    //#endregion

    //#region 发送邮件
    async SendEmail(data, actionlist) {
      let _data = []
      _.each(actionlist, (t) => {
        let m = _.find(this.sod_items_his, { id: t.id })
        if (m && m.fcGetDocumentApprover) {
          m.Approver = m.fcGetDocumentApprover.split(",")[0]
          _data.push(m)
        }
      })
      console.log(_data)
      let _this = this
      let _list = _.orderBy(_data, ["id"], ["desc"])
      if (_list.length > 0) {
        let _so_ids = []
        _.each(_list, (t) => {
          _so_ids.push(t.id)
        })

        let notify_list = []

        //====审批
        let order_email_list = _.filter(_list, { fcCheckDocumentAllApproved: false })
        if (order_email_list.length > 0) {
          ///发送邮件
          let content_list = [], exception_list = []
          let group_by_approver = _.groupBy(order_email_list, "Approver")
          for (let g in group_by_approver) {
            let _gt = group_by_approver[g]
            for (let d in _gt) {
              let dm = _.cloneDeep(_gt[d])
              dm.price_wotax == "" ? 0 : dm.price_wotax
              dm.price_vend_wotax == "" ? 0 : dm.price_vend_wotax
              let content_list_m = {
                ItemId: dm.ItemId,
                NameAlias: dm.NameAlias,
                VendAccountName: dm.SEI_Name,
                InitialVendPrice: _.round(dm.price_vend_wotax, 2),
                VendPrice: _.round(dm.price_wotax, 2),
                Sales_Order_Price: _.round(dm.Sales_Order_Price, 2),//实际销售价
                ProfitRate: dm.Sales_Order_Price == 0 ? "-100%" : _.round((dm.Sales_Order_Price - dm.price_wotax) * 100 / dm.Sales_Order_Price, 2), //(订单价格-实际采购价)/订单价格
                InitialProfitRate: dm.Sales_Order_Price == 0 ? "-100%" : _.round((dm.Sales_Order_Price - dm.price_vend_wotax) * 100 / dm.Sales_Order_Price, 2), //(订单价格-初始采购价)/订单价格
                Qty: dm.qty, //派发数量
                Amount: _.round(dm.price_wotax * dm.qty, 2), //派发金额
                isAXError: dm.isAXError ? "异常" : "",
                AXError: dm.AXError,
                Remark: dm.TEC_CommonRemark, //通用备注
                PriceRemark: dm.price_remark, //实际采购价备注
              }
              ///出现异常则不发邮件给供应商通知人以及派发创建人
              if (dm.isAXError) {
                exception_list.push(content_list_m)
              }
              else {
                content_list.push(content_list_m)
              }
            }
            if (g != "" && content_list.length > 0) {
              let lang_code = notify_template.methods.getUserLangCode(this, g)
              let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

              let email_data = {
                main: {
                  Title: "",
                  Url: window.location.protocol + "//" + window.location.host + "/sd/saleOrderDispatch?k=" + _gt[0].SalesId,
                  Url_Name: window.location.host + "/sd/saleOrderDispatch?k=" + _gt[0].SalesId,
                  UserName: this.$global.global_data.local_username,
                  SendDate: this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss")
                },
                list: content_list
              }
              let email_content = notify_template.methods.getTemplate(this, "vend_purch_price_change", email_data, g)

              let _send_to = {}
              _send_to[g] = ""
              let _notify_p = {
                category: "SalesOrderDispatch",
                idx: "",
                itemId: 0,
                notify_type: "SalesOrderDispatch",
                subject: _gt[0].SalesId + email_template["sod_wait_approve_be_care"],
                content: email_content,
                SendTo: _send_to
              }
              notify_list.push(_notify_p)
            }
          }
          ///如果出现异常则发邮件给异常处理人
          if (exception_list.length > 0) {
            let _profit_m = _.find(
              this.$store.state.biz_data.baseData.SystemSetting,
              { code: "email_notifier" }
            )
            if (_profit_m && _profit_m.setting_value != "") {
              let m = JSON.parse(_profit_m.setting_value)
              if (m.dispatchErrorEmailNotifier && m.dispatchErrorEmailNotifier.length > 0) {
                let eusers = []
                let roles = _.map(
                  this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
                  "code"
                )
                for (let i in m.dispatchErrorEmailNotifier) {
                  if (_.includes(roles, m.dispatchErrorEmailNotifier[i])) {
                    let _result = await RoleManageController.methods.GetRoleUsers(-1, m.dispatchErrorEmailNotifier[i])
                    _result = _.filter(_result, { is_sys: false })
                    if (_result && _result.length > 0) {
                      _.each(_result, (t) => {
                        eusers.push(t)
                      })
                    }
                  }
                  else {
                    eusers.push(m.dispatchErrorEmailNotifier[i])
                  }
                }
                eusers = _.uniq(eusers)//去除重复项
                _.each(eusers, (tm) => {
                  let lang_code = notify_template.methods.getUserLangCode(this, tm)
                  let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

                  let email_data = {
                    main: {
                      Title: "",
                      Url: window.location.protocol + "//" + window.location.host + "/sd/saleOrderDispatch",
                      Url_Name: window.location.host + "/sd/saleOrderDispatch",
                      UserName: this.$global.global_data.local_username,
                      SendDate: this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss")
                    },
                    list: exception_list
                  }
                  let email_content = notify_template.methods.getTemplate(this, "vend_purch_price_change_exception", email_data, tm)

                  let _send_to = {}
                  _send_to[tm] = ""
                  let _notify_p = {
                    category: "SalesOrderDispatch",
                    idx: "",
                    itemId: 0,
                    notify_type: "SalesOrderDispatch",
                    subject: email_template["sod_ax_error_handing"],
                    content: email_content,
                    SendTo: _send_to
                  }
                  notify_list.push(_notify_p)
                })
              }
            }
          }
          if (notify_list.length > 0) {
            let _rsult = await commonController.methods.sendOrCancelNotify(
              "add",
              notify_list
            )
            if (!_.isNull(_rsult) && !data.is_not_notify) {
              _this.msgToasts(this.$t("notify.email_seccess"), "success")
            }
          }
        }

      }
    },
    ///审批后发邮件
    async sendEmailAfterApproved(data, _p) {
      let _groupby_user = _.groupBy(data, "create_by_username")
      ///发邮件给派发人
      await this.exSendEmailAfterApproved(_groupby_user, _p, "vend")
      ///发邮件给订单创建人
      await this.exSendEmailAfterApproved(_.groupBy(data, "sd_create_by_username"), _p)
      ///根据派发人发送邮件
      let list = []
      for (let i in data) {
        let _m = _.cloneDeep(data[i])
        let vend = _.find(this.$store.state.biz_data.baseData.Vender, {
          AccountNum: _m.AccountNum,
        })
        if (vend && vend.EmailNotifier && vend.EmailNotifier != "") {
          //邮件通知人
          let _dt = _.split(vend.EmailNotifier, ",")
          if (_dt && _dt.length > 0) {
            _.each(_dt, (n) => {
              _m.create_by_username = n
              list.push(_.cloneDeep(_m))
            })
          }
        }
      }
      if (list.length > 0) {
        let _groupby_dispatch_user = _.groupBy(list, "create_by_username")
        await this.exSendEmailAfterApproved(_groupby_dispatch_user, _p, "vend")
      }
    },
    async exSendEmailAfterApproved(_groupby_user, _p, type) {
      let notify_list = []
      for (let d in _groupby_user) {
        let lang_code = notify_template.methods.getUserLangCode(this, d)
        let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

        let _email_params = {
          notify_type: _p.notify_type,
          subject: email_template[_p.subject],
          create_by_username: d,
          list: _groupby_user[d],
          idx: _p.idx,
        }
        let _ep = notify_template.methods.getApprovedEmailTemplate(_email_params, this, type)
        notify_list.push(_ep)
      }
      if (notify_list.length > 0) {
        await commonController.methods.sendOrCancelNotify("add", notify_list)
      }
    },
    //#endregion
  }
}
</script>
<style scoped>
.page_component__scroll {
  height: 100vh;
  overflow-x: hidden;
}
</style>
